import { useEffect } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemas = [
  // WebSite
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'スカウトブースト',
    url: SITE_URL,
  },
  // Organization
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'スカウトブースト',
    url: SITE_URL,
    logo: `${SITE_URL}/vite.svg`,
    sameAs: ['https://hapicareers.com/'],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: 'Japanese',
    },
  },
  // Service
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '新卒採用スカウト送信代行サービス',
    description:
      'OfferBox・dodaキャンパスに対応した新卒採用スカウト送信代行サービス。ターゲット選定・文面作成・スカウト送信・レポート提供まで専門チームが一貫して支援します。',
    provider: {
      '@type': 'Organization',
      name: 'スカウトブースト',
      url: SITE_URL,
    },
    areaServed: 'JP',
    inLanguage: 'ja',
    offers: [
      {
        '@type': 'Offer',
        name: 'ライトプラン',
        price: '49800',
        priceCurrency: 'JPY',
        description: '月間スカウト送信数 最大50通。採用担当者が初めてスカウト代行を試したい企業に。',
      },
      {
        '@type': 'Offer',
        name: 'スタンダードプラン',
        price: '89800',
        priceCurrency: 'JPY',
        description: '月間スカウト送信数 最大150通。本格的な母集団形成を目指す標準プラン。',
      },
      {
        '@type': 'Offer',
        name: 'プレミアムプラン',
        price: '149800',
        priceCurrency: 'JPY',
        description: '月間スカウト送信数 最大300通。採用戦略から一貫して伴走するフルサポートプラン。',
      },
    ],
  },
  // WebPage
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'スカウトブースト｜新卒採用スカウト代行 - OfferBox・dodaキャンパス対応',
    description:
      '新卒採用のスカウト送信を専門チームが代行。OfferBox・dodaキャンパスに対応し、ターゲット選定から送信管理まで一貫支援。返信率にコミットした採用活動を実現します。',
    url: SITE_URL,
    inLanguage: 'ja',
    isPartOf: {
      '@type': 'WebSite',
      name: 'スカウトブースト',
      url: SITE_URL,
    },
  },
  // FAQPage
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '初期費用はかかりますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '初期費用は一切かかりません。月額費用のみでご利用いただけます。また、解約時の違約金もございませんので、安心してお試しいただけます。',
        },
      },
      {
        '@type': 'Question',
        name: '途中でプランを変更することはできますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい、可能です。採用活動の状況やご予算に応じて、月単位でプランの変更が可能です。変更のご希望は翌月から反映いたします。',
        },
      },
      {
        '@type': 'Question',
        name: '料金に含まれるものを教えてください。',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '月額料金にはターゲット設計・文面作成・スカウト送信・レポート提供がすべて含まれます。媒体の利用料（OfferBox / dodaキャンパスの契約費）は別途お客様にてご用意いただく必要があります。',
        },
      },
      {
        '@type': 'Question',
        name: '最低契約期間はありますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '最低3ヶ月からのご契約となります。スカウト採用は効果が出るまでに一定の期間とデータ蓄積が必要なため、3ヶ月を最短期間として設定しています。',
        },
      },
      {
        '@type': 'Question',
        name: '途中解約はできますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '最低契約期間（3ヶ月）経過後は、1ヶ月前のご通知にて解約が可能です。解約違約金は発生しません。',
        },
      },
      {
        '@type': 'Question',
        name: '担当者は毎回同じ人が対応してくれますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい。ご契約いただいた企業様ごとに専任の担当者がアサインされます（プレミアムプラン）。スタンダードプランは担当チーム制となりますが、引き継ぎの手間なくご対応いたします。',
        },
      },
      {
        '@type': 'Question',
        name: '進捗報告はどのくらいの頻度で受け取れますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'スタンダード・プレミアムプランでは毎週のレポートをお届けし、週次MTGにて数値のご説明と改善提案を実施します。ライトプランは月次レポートの提供となります。',
        },
      },
      {
        '@type': 'Question',
        name: '媒体のアカウントは自社で用意する必要がありますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい。OfferBox・dodaキャンパスの企業アカウントはお客様ご自身でご契約いただく必要があります。アカウント開設のサポートについてはお気軽にご相談ください。',
        },
      },
      {
        '@type': 'Question',
        name: '返信率に保証はありますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '特定の数値保証は設けておりませんが、業界平均（約2〜3%）を上回る返信率の実現を目標に、継続的な改善を実施しています。週次PDCAにより、送信内容・ターゲット・タイミングを柔軟に調整します。',
        },
      },
      {
        '@type': 'Question',
        name: 'OfferBox・dodaキャンパス以外の媒体にも対応できますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '現在はOfferBox・dodaキャンパスの2媒体に特化してサービスを提供しています。他媒体への対応ご希望については、まずはお問い合わせにてご相談ください。',
        },
      },
    ],
  },
];

export default function SEOJsonLd() {
  useEffect(() => {
    schemas.forEach((schema, index) => {
      const id = `ld-json-${index}`;
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });

    return () => {
      schemas.forEach((_, index) => {
        const el = document.getElementById(`ld-json-${index}`);
        if (el) el.remove();
      });
    };
  }, []);

  return null;
}
